var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":12,"offset":6}},[_c('el-card',{staticClass:"box-card"},[_c('ImportTransactions')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }